export default {
  UNKNOWN: -1,
  INVALID_RESPONSE: -2,
  AUTH_INVALID_TOKEN: 9000,
  AUTH_USER_NOT_FOUND: 9001,
  AUTH_INCORRECT_PASSWORD: 9002,
  AUTH_INVALID_REFRESH_TOKEN: 9003,
  AUTH_CONFIRM_PASSWORD_NOT_MATCH: 9007,
  AUTH_NEW_PASSWORD_IS_THE_SAME_CURRENT_PASSWORD: 9008,

  ANOTHER_CLIENT_USED_THAT_INFO: 3002,

  CALL_LOG_ALREADY_EXISTS: 6001,

  CASH_LOG_CLOSURE_EXISTS: 7001,
  CASH_LOG_BRANCH_NOT_FOUND: 7002,
  CASH_LOG_CANNOT_BE_BEFORE_CLOSURE_DATE: 7003,
  CASH_LOG_CLOSURE_IS_NOT_LATEST: 7004,
  CASH_LOG_PENDING_LOGS_IN_CLOSURE_RANGE: 7005,
  CASH_LOG_FUND_NOT_FOUND: 7006,
  CASH_LOG_CANNOT_BE_A_FUTURE_DATE: 7007,
  CASH_LOG_CANNOT_REMOVE: 7008
};
